/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useCountriesList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const CountrySelect = React.forwardRef(({ placeholder = 'Type to search country', children, ...props }, ref) => (
  <SearchableEntitySelect ref={ref} placeholder={placeholder} useList={useCountriesList} {...props} />
));

export default CountrySelect;
